export class PasswordPolicy {
  constructor() {}
  private strengthLevel: number;
  org_id: string;
  requiredNumberOfCharsOnChange: number;
  minimumPasswordLifeCycle: number;
  maximiumPasswordLifeCycle: number;
  lockoutThreshold: number;
  locoutDuration: number;
  enforceCustumList: boolean;
  customBannedList: string[];
  passwordHistory: boolean;
  passwordHistorySize: number;
  personalData: boolean;
  modifiedBy: string;
  _id: string;
  lockoutTimeBound: number;
  regexValidators: any[];
  minGenerationsUse: number;
  minPasswordLengthAllowed: number = 8;
  userinactivityThreshold:Number;
  nonPriviledgeUserInactivityThreshold:Number;
  sessionInactivityThreshold:Number;
  numberOfSessionsPerUser:Number;
  maxPasswordLengthAllowed:number=255;
  //Setter
  set passwordStrengthLevel(value: number) {
    this.strengthLevel = value;
    const minLength = this.minPasswordLength
    var regex = [
      { text: `Password should be Non-empty`, value: `(.|\\s)*\\S(.|\\s)*` },
      {
        text: `Password should be ` + minLength + ` characters in length`,
        value: `^.{` + minLength + `,}$`,
      },
      {
        text: `Password should contain atleast 1 lowercase, 1 uppercase, 1 number`,
        value: `(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).*`,
      },
      {
        text: `Password should contain atleast 1 special character`,
        value: `[!@#$%^&*(),.?":{}|<>]`,
      },
      {
        text: `Password should not contain more than 2 identical characters in a row`,
        value: `^(?!.*(\\w)\\1{2,}).+$`,
      },
    ];
    this.regexValidators = regex.slice(0, value);
    // this.regexValidators.unshift({text:`Password can not start and end with whitespaces`,value:`^[^\\s].+[a-zA-Z]+[a-zA-Z]+$`});//[{text:`Password can not start and end with whitespaces`,value:`^[^\s].+[^\s]$`},...this.regexValidators.slice()];//basic validation for all;
  }
  //Getter
  get passwordStrengthLevel(): number {
    return this.strengthLevel;
  }
  //copy object properties
  public map(source: PasswordPolicy): void {
    Object.keys(source).map((key, index) => {
      this[key] = source[key];
    });
  }
  setMinPasswordLength() {
    const minLength = this.minPasswordLength;
    var regex = [
      { text: `Password should be Non-empty`, value: `(.|\\s)*\\S(.|\\s)*` },
      {
        text: `Password should be ` + minLength + ` characters in length`,
        value: `^.{` + minLength + `,}$`,
      },
      {
        text: `Password should contain atleast 1 lowercase, 1 uppercase, 1 number`,
        value: `(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).*`,
      },
      {
        text: `Password should contain atleast 1 special character`,
        value: `[!@#$%^&*(),.?":{}|<>]`,
      },
      {
        text: `Password should not contain more than 2 identical characters in a row`,
        value: `^(?!.*(\\w)\\1{2,}).+$`,
      },
    ];
    this.regexValidators = regex.slice(0, this.strengthLevel);
  }
  /**
   * To get minimum password length set by the user
   * @readonly
   * @memberof PasswordPolicy
   */
  get minPasswordLength() {
    let minLength = $(".input-length").val();
    if (minLength < 8 || minLength == "") {
      $(".input-length").val(this.minPasswordLengthAllowed);
      return this.minPasswordLengthAllowed;
    }
    if(minLength>this.maxPasswordLengthAllowed){
      $(".input-length").val(this.maxPasswordLengthAllowed);
      return this.maxPasswordLengthAllowed
    }
    return minLength;
  }
}
